import http from '@/base/http';
import { CommonEdition, Editions } from '@/base/platform/editions';
import { baseUrl } from './rpc-config';
import { IBaseResponse } from './rpc-types';

export const withLocalePathSegment = (edition: string, locale: string) => {
    const editionInfo = Editions[edition] || CommonEdition;
    if (! editionInfo.locales?.find(l => l.name === locale)) {
        return '';
    }
    return (locale && locale !== 'zh') ? locale + '/' : '';
}

export class RPCService {

    async postJSON<T extends IBaseResponse, D = any>(url: string, data: D, params?: Record<string, string | number | boolean>): Promise<T> {
        if (url.startsWith('/')) {
            url = url.substring(1);
        }
        const urlObj = new URL(url, baseUrl);
        params = <Record<string, string | number | boolean>>(params || Object.create(null));
        urlObj.searchParams.forEach((value, name) => {
            if (params![name] === undefined) {
                params![name] = value;
            }
        });
        const headers = {
            // Cookie: authService.composeCookie(),
            // Authorization: `Bearer ${authService.getToken()}`,
            'Content-Type': 'application/json',
        };
        const res = await http.post<T>(urlObj.origin + urlObj.pathname, data, {headers, params});
        if (res.data.code !== 0) {
            throw new Error(`[${res.data.code}]${res.data.msg || res.data.message || 'unknown error'}`);
        }
        return res.data;
    }
    async getJSON<T extends IBaseResponse>(url: string, params?: Record<string, string | number | boolean>): Promise<T> {
        if (url.startsWith('/')) {
            url = url.substring(1);
        }
        const urlObj = new URL(url, baseUrl);
        params = <Record<string, string | number | boolean>>(params || Object.create(null));
        urlObj.searchParams.forEach((value, name) => {
            if (params![name] === undefined) {
                params![name] = value;
            }
        });
        const headers = {
            // Cookie: authService.composeCookie(),
            // Authorization: `Bearer ${authService.getToken()}`,
        };
        const res = await http.get<T>(urlObj.origin + urlObj.pathname, {headers, params});
        if (res.data.code !== 0) {
            throw new Error(`[${res.data.code}]${res.data.msg || res.data.message || 'unknown error'}`);
        }
        return res.data;
    }
}

export default new RPCService();
